jQuery(function($){
    $.datepicker.setDefaults($.datepicker.regional['cs']);
});